module.exports = __webpack_public_path__ + "static/img/mediamodifier_image.40b1353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mediamodifier_image.png
// module id = vDpe
// module chunks = 0